export const getShippingMethodsPayload = shippingMethods => {
  return shippingMethods?.map((shippingMethod, index) => ({
    enabled: shippingMethod.is_enabled,
    id: shippingMethod.id,
    position: index,
  }))
}
